export const REMOTE_CONSOLE_GUI_V2 = 'rc_gui_v2';
export const REMOTE_CONSOLE_CLASSIC = 'rc_classic';
